$(function () {
  function _autocomplete() {
    $('[data-behaviour~=autocomplete]').each(function (i) {
      var $this = $(this);
      var $target = $('#' + $this.data('target'));
      $this.autocomplete({
        source: $this.data('source'),
        focus: function( event, ui ) {
          $target.val(ui.item.value);
          $this.val(ui.item.label);
          return false;
        },
        select: function(e, ui) {
          $target.val(ui.item.value);
          $this.val(ui.item.label);
          return false;
        },
        change: function(e, ui) {
          if (!$this.val()) {
            $target.val('');
          }
          return false;
        }
      }).data('uiAutocomplete')._renderItem = function (ul, item) {
        return $("<li></li>").data("item.autocomplete", item)
                             .html('<a>' + item.label + '</a>')
                             .appendTo(ul);
      };
    });
  }
  $(document).bind('initialize-modal.custom', function () {
    _autocomplete();
  });
  _autocomplete();
})
